import { Box, styled, Typography } from '@mui/material';

import { isStinvestActiveClient } from '»utils/clientsUtils';

export const MainContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '40px',
  width: '100vw',
  height: '100vh',
}));

export const LogoImgStyled = styled('img')(({ theme }) => ({
  height: 'auto',
  width: '312.1px',

  [theme.breakpoints.up('md')]: {
    width: '410.2px',
  },
  [theme.breakpoints.up('xxl')]: {
    width: '637.2px',
  },
}));

export const TextStyled = styled(Typography)(({ theme }) => ({
  fontFamily: !isStinvestActiveClient && 'Roboto Mono',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,

  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
  },
  [theme.breakpoints.up('xxl')]: {
    fontSize: '40px',
  },
}));
